import refs from '../helpers/refs'
import Form from '../helpers/form'
import site from '../helpers/site'
import '../atoms/a-input-date'
import '../atoms/a-input-select'
import '../atoms/a-input-text'

class CContactForm {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()

    this.init()
  }

  init () {
    // Country/state behavior
    Form.handleCountryStateZip(this.$refs.countryDropdown)
    Form.handleCountrySubsidiary()
    // Email validation behavior
    Form.handleEmailFieldMatching()
    // Newsletter behavior
    Form.handleNewsletterOptIn()
    // File validation
    Form.handleFileValidation(['product', 'issue', 'additional'])

    if (this.site === 'masterbuilt') {
      // Product + type dropdowns
      Form.handleMBProductTypeDropdown()
      // Model number select or entry
      Form.handleMBModelNumber()
    } else if (this.site === 'chargriller') {
      // Product + type dropdowns
      Form.handleCGProductTypeDropdown()
      // Model number select or entry
      Form.handleCGModelNumber()
    } else {
      // Product + type dropdowns
      Form.handleKJProductTypeDropdown()
      // Model number select or entry
      Form.handleKJModelNumber()
    }

    // Topic select handler
    this.handleTopicDropdowns()

    this.component.querySelector('#support-form').addEventListener('submit', (event) => {
      const isValid = this.validateForm()

      if (!isValid) {
        event.preventDefault()
      } else {
        const zipFieldValue = document.querySelector('#zip-field').value
        const helpTopicValue = document.querySelector('#help-topic').value
        const helpTopicLabel = document.querySelector(`#help-topic option[value="${helpTopicValue}"]`).innerText

        window.dataLayer.push({
          event: 'contact_form_submit',
          event_category: 'contact_form_submit',
          event_action: zipFieldValue,
          event_label: helpTopicLabel
        })
      }

      return isValid
    })
  }

  handleTopicDropdowns () {
    const helpTopic = this.component.querySelector('#help-topic')

    helpTopic.addEventListener('change', (event) => {
      if (event.target.value === '9' || event.target.value === '12') {
        document.querySelector('#case-issue').setAttribute('value', 4)
      } else {
        document.querySelector('#case-issue').setAttribute('value', 56)
      }
      // remove required fields when topic is Accessibility
      if (event.target.value === '21') {
        this.toggleRequiredProductType(false)
        this.toggleRequiredModelNumber(false)
        this.toggleRequiredPurchaseDate(false)
        this.toggleRequiredPurchasePlace(false)
      } else {
        // restore required fields when topic is not Accessibility
        this.toggleRequiredProductType(true)
        this.toggleRequiredModelNumber(true)
        this.toggleRequiredPurchaseDate(true)
        this.toggleRequiredPurchasePlace(true)
      }
      this.checkRequireWarrantyImages()
    })
  }

  toggleRequiredProductType (required) {
    const productTypeField = document.querySelector('#product-type-field')
    const productTypeLabel = document.querySelector('#product-type-label')
    const requiredStar = ' *'
    const noStarProductType = productTypeLabel.innerHTML.replace(requiredStar, '')
    const withStarProductType = noStarProductType + requiredStar

    if (required) {
      productTypeLabel.innerHTML = withStarProductType
      productTypeField.required = true
    } else {
      productTypeLabel.innerHTML = noStarProductType
      productTypeField.required = false
    }
  }

  toggleRequiredModelNumber (required) {
    const modeNumberField = document.querySelector('#model-number-select')
    const modelNumberLabel = document.querySelector('#model-number-label')
    const requiredStar = ' *'
    const noStarModelNumber = modelNumberLabel.innerHTML.replace(requiredStar, '')
    const withStarModelNumber = noStarModelNumber + requiredStar

    if (required) {
      modelNumberLabel.innerHTML = withStarModelNumber
      modeNumberField.required = true
    } else {
      modelNumberLabel.innerHTML = noStarModelNumber
      modeNumberField.required = false
    }
  }

  toggleRequiredPurchaseDate (required) {
    const purchaseDateField = document.querySelector('#purchase-date-field')
    const purchaseDateLabel = document.querySelector('#purchase-date-label')
    const requiredStar = ' *'
    const noStarPurchaseDate = purchaseDateLabel.innerHTML.replace(requiredStar, '')
    const withStarPurchaseDate = noStarPurchaseDate + requiredStar

    if (required) {
      purchaseDateLabel.innerHTML = withStarPurchaseDate
      purchaseDateField.required = true
    } else {
      purchaseDateLabel.innerHTML = noStarPurchaseDate
      purchaseDateField.required = false
    }
  }

  toggleRequiredPurchasePlace (required) {
    const purchasePlaceField = document.querySelector('#purchase-place-field')
    const purchasePlaceLabel = document.querySelector('#purchase-place-label')
    const requiredStar = ' *'
    const noStarPurchasePlace = purchasePlaceLabel.innerHTML.replace(requiredStar, '')
    const withStarPurchasePlace = noStarPurchasePlace + requiredStar

    if (required) {
      purchasePlaceLabel.innerHTML = withStarPurchasePlace
      purchasePlaceField.required = true
    } else {
      purchasePlaceLabel.innerHTML = noStarPurchasePlace
      purchasePlaceField.required = false
    }
  }

  // this might not be used, but I'm not sure enough to remove it
  removeRequiredPurchasePlace (hideStar) {
    const purchasePlaceLabel = document.querySelector('#purchase-place-label')
    // const imageFieldLabel = document.querySelector('#product-image-label')
    const requiredStar = ' *'
    const noStarPurchasePlace = purchasePlaceLabel.innerHTML.replace(requiredStar, '')
    const withStarPurchasePlace = noStarPurchasePlace + requiredStar
    // const noStarImageField = imageFieldLabel.innerHTML.replace(requiredStar, '')
    // const withStarImageField = noStarImageField + requiredStar

    // no * by default
    if (hideStar) {
      purchasePlaceLabel.innerHTML = noStarPurchasePlace
      // imageFieldLabel.innerHTML = noStarImageField
    } else {
      purchasePlaceLabel.innerHTML = withStarPurchasePlace
      // imageFieldLabel.innerHTML = withStarImageField
    }
  }

  checkRequireWarrantyImages () {
    const helpTopic = document.querySelector('#help-topic')
    const image1 = document.querySelector('#image-field') // "Attach an image of your product"
    const image1Label = document.querySelector('#product-image-label')
    const image1Hint = document.querySelector('#product-image-hint')
    image1Hint.innerText = window.customerServiceErrorStrings.warranty_product_image
    const image2 = document.querySelector('#addl-image-1-field') // "Attach an image of the issue"
    const image2Label = document.querySelector('#addl-image-1-field-label')
    const image2Hint = document.querySelector('#addl-image-1-field-hint')
    image2Hint.innerText = window.customerServiceErrorStrings.warranty_issue_image
    const requiredStar = ' *'
    const image1NoStar = image1Label.innerHTML.replace(requiredStar, '')
    const image2NoStar = image2Label.innerHTML.replace(requiredStar, '')
    const image1WithStar = image1NoStar + requiredStar
    const image2WithStar = image2NoStar + requiredStar

    if (helpTopic.value === '10') {
      alert(window.customerServiceErrorStrings.warranty_images)
      image1.setAttribute('required', true)
      image2.setAttribute('required', true)
      image1Label.innerHTML = image1WithStar
      image2Label.innerHTML = image2WithStar
      image1Hint.classList.remove('hidden')
      image2Hint.classList.remove('hidden')
    } else {
      image1.removeAttribute('required')
      image2.removeAttribute('required')
      image1Label.innerHTML = image1NoStar
      image2Label.innerHTML = image2NoStar
      image1Hint.classList.add('hidden')
      image2Hint.classList.add('hidden')
    }
  }

  validateForm () {
    // change style of button so can tell it's been clicked
    document.querySelector('#submit-btn').setAttribute('disabled', true)
    document.querySelector('.please-wait').classList.remove('hidden')
    const purchaseDateField = document.getElementById('purchase-date-field')
    const zipField = document.getElementById('zip-field')
    const firstName = document.getElementById('first-name-field').value
    const lastName = document.getElementById('last-name-field').value
    let formIsValid = true

    // Clear previous error messages
    Form.hideAllErrors()

    // Check required fields
    formIsValid = Form.validateRequiredFields(this.component)

    // If all required fields are present, validate values entered
    if (formIsValid) {
      if (purchaseDateField.value.length > 0) {
        Form.formatDate(purchaseDateField)
      }

      if (!(formIsValid &&= Form.validZip(zipField.value))) {
        Form.showError(zipField.closest('.a-input-text'), window.customerServiceErrorStrings.invalid_zip)
      }

      formIsValid &&= Form.validateEmail()
      formIsValid &&= Form.validateFileSizes(['product', 'issue', 'additional'])
      formIsValid &&= Form.validateFileFormat()
      formIsValid &&= Form.validateBannedName(firstName, lastName)
    }

    // re-enable submit button
    document.querySelector('#submit-btn').removeAttribute('disabled')
    document.querySelector('.please-wait').classList.add('hidden')

    if (!formIsValid) {
      // Set focus on the first error field
      Form.focusFirstError(this.component)
    }

    return formIsValid
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-contact-form')
    .forEach(el => new CContactForm(el))
})
